import React from 'react'

import ListItem from "./ListItem";
import MenuListItem from "./MenuListItem";

const MenuList = ({ data, currentMenu, onMenuClick }) => {

  const getCurrentNode = (node) => {
    let menuSet = new Set(currentMenu);
    let menu = [...menuSet];
    if (data?.child?.length) {
      let parent = data?.child?.find((node) => node?.name === menu?.[1]);
      let child = parent?.child?.find((ele) => ele?.name === node?.name)
      if (child) {
        return true;
      }
      return false;
    }
    return false

  }


  const renderNode = (node, path, index) => {
    const nodePath = [...path, node?.name];
    const isOpen =
      nodePath?.join('/') === currentMenu?.slice(0, index + 1)?.join('/');

    if (node?.child?.length) {
      return (
        <MenuListItem
          key={node?.name}
          node={node}
          isOpen={isOpen}
          currentMenu={currentMenu}
          onMenuClick={() => { onMenuClick(nodePath, index, true) }}
        >
          {isOpen &&
            node?.child?.map((child) =>
              renderNode(child, nodePath, index + 1)
            )}
        </MenuListItem>
      );
    } else {
      return <ListItem key={node?.name} node={node} onMenuClick={() => { onMenuClick(nodePath, index, getCurrentNode(node)) }} />;
    }
  };


  return <>{renderNode(data, [], 0)}</>;
};

export default MenuList;